import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFingerprintFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.294 15.428c-.39.25-.837.382-1.294.382a2.403 2.403 0 0 1-2.4-2.4V10.6A2.404 2.404 0 0 1 12 8.2a2.404 2.404 0 0 1 2.401 2.4v2.81a1 1 0 1 0 2 0V10.6A4.406 4.406 0 0 0 12 6.2a4.405 4.405 0 0 0-4.4 4.4v2.81a4.405 4.405 0 0 0 4.4 4.4c.84 0 1.661-.24 2.374-.698a1 1 0 1 0-1.08-1.684"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.998 10.81v2.54a1 1 0 1 0 2 0v-2.54a.999.999 0 1 0-2 0M8.149 20.25H6.89a3.144 3.144 0 0 1-3.142-3.14v-1.569a.75.75 0 0 0-1.5 0v1.569a4.646 4.646 0 0 0 4.642 4.64h1.258a.75.75 0 0 0 0-1.5M20.998 14.791a.75.75 0 0 0-.75.75v1.569c0 1.732-1.41 3.14-3.143 3.14h-1.289a.75.75 0 0 0 0 1.5h1.29a4.647 4.647 0 0 0 4.642-4.64v-1.569a.75.75 0 0 0-.75-.75M2.998 9.22a.75.75 0 0 0 .75-.75V6.9a3.15 3.15 0 0 1 3.143-3.151H8.18a.75.75 0 0 0 0-1.5H6.891A4.65 4.65 0 0 0 2.248 6.9v1.57c0 .414.336.75.75.75M17.107 2.25H15.85a.75.75 0 0 0 0 1.5h1.258A3.15 3.15 0 0 1 20.25 6.9v1.571a.75.75 0 0 0 1.5 0V6.9a4.65 4.65 0 0 0-4.643-4.65"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFingerprintFilled);
export default ForwardRef;
